module.exports = __webpack_public_path__ + "media/images/challenges/golden-ticket-22/2015_professional_winner-7bf3d014679b5c18fc5de387e2dca934.jpg";